import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import {
  CompanyNotificationActions,
  CompanyNotificationActionTypes,
} from '../_actions/company-notification.actions';
import { CompanyNotificationModel } from '../../../notification/models/company-notification.model';
import { QueryParamsModel } from '../../_base/crud';

export interface CompanyNotificationsState extends EntityState<CompanyNotificationModel> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedCompanyNotificationId: number;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  error: any | null;
  latestSuccessfullAction: any;
}

export const adapter: EntityAdapter<CompanyNotificationModel> =
  createEntityAdapter<CompanyNotificationModel>();

export const initialCompanyNotificationsState: CompanyNotificationsState = adapter.getInitialState({
  companyNotificationForEdit: null,
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  lastCreatedCompanyNotificationId: undefined,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  error: null,
  latestSuccessfullAction: null,
});

export function companyNotificationsReducer(
  state = initialCompanyNotificationsState,
  action: CompanyNotificationActions,
): CompanyNotificationsState {
  switch (action.type) {
    case CompanyNotificationActionTypes.CompanyNotificationsPageToggleLoading: {
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedCompanyNotificationId: undefined,
      };
    }
    case CompanyNotificationActionTypes.CompanyNotificationActionToggleLoading: {
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    }
    case CompanyNotificationActionTypes.CompanyNotificationsPageCancelled: {
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
        showInitWaitingMessage: false,
      };
    }
    case CompanyNotificationActionTypes.CompanyNotificationsPageLoaded: {
      return adapter.addMany(action.payload.companyNotifications, {
        ...initialCompanyNotificationsState,
        totalCount: action.payload.totalCount,
        listLoading: false,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case CompanyNotificationActionTypes.ThrowCompanyNotificationError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case CompanyNotificationActionTypes.FireCompanyNotificationSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getCompanyNotificationState =
  createFeatureSelector<CompanyNotificationModel>('companyNotifications');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
